import { DataTable } from "@msuite/ui/table";
import { useIncomingInvoice } from "@/hooks/use-incoming-invoice";
import type { IncomingInvoicePanelBaseProps } from "../../shared";
import type { DecisionRow } from "./decision-row";
import { columns } from "./decisions-table-config";

/**
 * Every decision taken in the invoice's approval chain, newest first — including those taken back
 * since or sent back to pending by a later handover, which the approvals table no longer shows.
 */
export function IncomingInvoiceDecisions({ incomingInvoiceId }: IncomingInvoicePanelBaseProps) {
	/** Query */
	const { incomingInvoice, isLoading, queryKey, refetch } = useIncomingInvoice(incomingInvoiceId);

	/** Computed */
	const rows: DecisionRow[] = (incomingInvoice?.decisions ?? [])
		.map((decision) => ({ ...decision, currency: incomingInvoice?.currency ?? "EUR" }))
		.reverse();

	/** Render */
	return (
		<DataTable
			data={rows}
			columns={columns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
			persistenceKey="incoming-invoice-decisions-table"
		/>
	);
}
